function plugin(Vue, Loading) {
    let component, container, propsData, counter

    propsData = {
        show: false,
        text: 'Loading...'
    }

    counter = 0
    container = document.createElement('div')
    document.getElementsByTagName('body')[0].appendChild(container)

    component = new Loading({

            props: propsData,
            el: container

    })
    

    function method(show, text = 'Loading...') {
        
        component.$set('text', text)

        counter = show ? counter + 1 : counter - 1

        if (!show && counter === -1) {
            counter = 0
            return
        }

        if (!show && counter !== 0) {
            return
        }

        component.show = show
    }

    Vue.loading = method
    Vue.prototype.$loading = method
}

module.exports = plugin


// WEBPACK FOOTER //
// ./src/components/editor/loading/plugin.js